import { Injectable } from '@angular/core';
import { TableHints } from '@app/shared/models/table-hint.model';
import { fullHintList } from './schemas/schema-hints';

@Injectable({
  providedIn: 'root',
})
export class TableHintService {
  get(): TableHints {
    return this.build(fullHintList);
  }

  private build(tableHints: Record<string, string[]>): TableHints {
    const modified: Record<string, string[]> = {};
    const keys: Set<string> = new Set();
    for (const rec in tableHints) {
      modified[rec] = tableHints[rec];
      keys.add(rec);
    }
    return {
      hints: modified,
      keys,
    };
  }
}
